export function getView(is_new_profile_enabled, active_tab) {
  return is_new_profile_enabled && active_tab === 'profile'
}
